import { v4 } from "uuid"
import { LinqsetEdge, LinqsetNode } from "./linqset-base"
import { MODEL_CHANGE, ModelAnalytics, ModelDetails } from "./organisation"
import { User } from "./user"

export enum CHANGE_TYPE {
    DELETED,
    ADDED,
    CHANGED
}

export interface LinqsetChanges {
    nodeChanges: any[]      // each the key of a node and the fields of it that changed (or the whole node)
    edgeChanges: LinqsetEdge[]
    deletedNodes: LinqsetNode[]
    deletedEdges: LinqsetEdge[]
    newNodes: LinqsetNode[]
    newEdges: LinqsetEdge[]
    newModel?: ModelDetails  // when moving nodes we also create a new model
}

export const createLinqsetChanges = ():LinqsetChanges => {
    return {
        nodeChanges: [],
        edgeChanges: [],
        deletedNodes: [],
        deletedEdges: [],
        newNodes: [],
        newEdges: []
    } as LinqsetChanges
}

// how many nodes and edges were changed, added or deleted. Changes sent by an older client may not have every list
export const getNumberOfChanges = (changes:LinqsetChanges|undefined) => {
    if (!changes) return 0

    return (changes.nodeChanges?.length||0) + (changes.edgeChanges?.length||0) + (changes.deletedEdges?.length||0) +
        (changes.deletedNodes?.length||0) + (changes.newEdges?.length||0) + (changes.newNodes?.length||0)
}

const describe = (n:number, one:string, many:string) => `${n} ${n === 1 ? one : many}`

// the unsaved changes, described for the user
export const getListOfChanges = (changes:LinqsetChanges|undefined):string[] => {
    if (!changes) return []
    const response:string[] = []
    const count = (list?:unknown[]) => list?.length || 0
    if (count(changes.nodeChanges) > 0) response.push(describe(count(changes.nodeChanges), "node changed", "nodes changed"))
    if (count(changes.edgeChanges) > 0) response.push(describe(count(changes.edgeChanges), "edge changed", "edges changed"))
    if (count(changes.deletedNodes) > 0) response.push(describe(count(changes.deletedNodes), "node deleted", "nodes deleted"))
    if (count(changes.deletedEdges) > 0) response.push(describe(count(changes.deletedEdges), "edge deleted", "edges deleted"))
    if (count(changes.newNodes) > 0) response.push(describe(count(changes.newNodes), "node added", "nodes added"))
    if (count(changes.newEdges) > 0) response.push(describe(count(changes.newEdges), "edge added", "edges added"))
    return response
}

export const createModelAnalytics = (organisationKey:string, user:User, type:MODEL_CHANGE, change:LinqsetChanges, modelKey:string, modelName:string, projectKey?:string):ModelAnalytics => {
    return {
        _key:v4(),
        type,
        createdDate: new Date(),
        organisationKey:organisationKey,
        modelKey:modelKey,
        projectKey: projectKey,
        modelName: modelName,
        userKey: user._key,
        userName: user.name,
        nodeChanges: change.nodeChanges?.length||0,
        edgeChanges: change.edgeChanges?.length||0,
        deletedNodes: change.deletedNodes?.length||0,
        deletedEdges: change.deletedEdges?.length||0,
        newNodes: change.newNodes?.length||0,
        newEdges: change.newEdges?.length||0
    } as ModelAnalytics
}
